export const NAMESPACE = 'activity-logs';
